import '../../styles/App.css';
import PathDivRender from './PathDivRender.js';
import Station from './Station.js';
import { stations } from '../../static/data/Stations.js';
import { useRef } from 'react';
 
export default function MapRender() {
        const outerPathRef = useRef(null);
        const middlePathRef = useRef(null);
        const innerPathRef = useRef(null);
        const mapContainer = useRef(null);

        const arr = [];
        for (var i=0;i<stations.length;i++) {
                const stationPercValue=((100/(stations.length))*i)+(100/(stations.length));
                /*arr.push(<PathDivRender renderedComp={Station} renderedCompProps={{"Station": stations[i]}} pathRef={middlePathRef} containerRef={mapContainer} perc={stationPercValue}/>);*/
        }

        return (
            <>
                <div id="map-render" ref={mapContainer}>
                {arr}
                <svg id="map-svg" version="1.1" preserveAspectRatio="none" x="0px" y="0px" viewBox="0 0 1280 720">
                <defs>
                <g id="Layer3_0_FILL">
                <path fill="#B7BAB8" stroke="none" d="
                M 202.15 354.9
                Q 197.037890625 354.6904296875 197 360.1
                L 197 417.55
                Q 197.05 422.95 202.2 422.7
                L 234.1 422.7
                Q 233.52734375 418.714453125 233.05 414.7 230.4763671875 393.1513671875 232.25 371.5 232.9595703125 363.1662109375 234.15 354.9
                L 202.15 354.9
                M 906.05 379.45
                Q 905.02890625 366.748046875 900.75 354.95
                L 360.5 354.9
                Q 359.2361328125 358.6173828125 358.25 362.45 354.0931640625 378.501171875 355.1 395.5 355.9166015625 409.621875 360.4 422.7
                L 901 422.7
                Q 901.11953125 422.38828125 901.2 422.05
                L 901.2 422.1
                Q 907.974609375 401.9353515625 906.05 379.45
                M 1027.1 354.95
                Q 1027.726171875 358.9849609375 1028.2 363.05
                L 1028.2 363.05
                Q 1030.670703125 384.5603515625 1028.85 406.2 1028.17421875 414.508203125 1026.95 422.7
                L 1058.75 422.7
                Q 1063.9 422.95 1063.95 417.55
                L 1063.95 360.1
                Q 1063.9 354.7 1058.75 354.95
                L 1027.1 354.95 Z"/>

                <path fill="#F57D0C" stroke="none" d="
                M 1023.65 388.8
                Q 1022.25 320.1 989.05 270.75 955.9 221.35 916.75 199.9 877.65 178.4 840.55 172.3 822.1 169.3 809.75 169.35
                L 451.35 169.35
                Q 439 169.3 420.55 172.3 383.44609375 178.4 344.3 199.85 305.21171875 221.35 272 270.7 238.834375 320.1 237.45 388.8 238.85 457.5 272.05 506.85 305.2 556.25 344.35 577.7 383.45 599.2 420.55 605.3 439 608.3 451.35 608.25
                L 809.75 608.25
                Q 822.1 608.3 840.55 605.3 877.65 599.2 916.75 577.7 955.9 556.25 989.05 506.85 1022.25 457.5 1023.65 388.8
                M 831.65 227.05
                L 831.55 227.05
                Q 859.959375 232.012109375 890 248.5
                L 890.05 248.55
                Q 918.423828125 265.1033203125 942.95 301.65
                L 943 301.7
                Q 958.446875 325.4150390625 964.4 354.95 967.674609375 371.0111328125 968.1 388.8 967.673828125 406.6173828125 964.4 422.7 958.4333984375 452.2056640625 943 475.85
                L 942.95 475.9
                Q 918.423828125 512.4966796875 890.05 529
                L 890 529.05
                Q 859.959375 545.587890625 831.55 550.5
                L 831.65 550.5
                Q 818.657421875 552.6341796875 809.95 552.75
                L 451.1 552.75
                Q 442.442578125 552.6341796875 429.45 550.5
                L 429.55 550.5
                Q 401.1404296875 545.587890625 371.1 529.05
                L 371 529
                Q 342.676171875 512.4966796875 318.1 475.9
                L 318.1 475.85
                Q 302.6666015625 452.2056640625 296.65 422.7 293.4259765625 406.6173828125 292.95 388.8 293.42578125 370.997265625 296.65 354.9 302.6595703125 325.4048828125 318.1 301.7
                L 318.1 301.65
                Q 342.676171875 265.1033203125 371 248.55
                L 371.1 248.5
                Q 401.1404296875 232.012109375 429.55 227.05
                L 429.45 227.05
                Q 442.442578125 224.9658203125 451.1 224.85
                L 809.95 224.85
                Q 818.657421875 224.9658203125 831.65 227.05 Z"/>

                <path fill="#4E4B4C" stroke="none" d="
                M 831.55 227.05
                L 831.65 227.05
                Q 818.657421875 224.9658203125 809.95 224.85
                L 451.1 224.85
                Q 442.442578125 224.9658203125 429.45 227.05
                L 429.55 227.05
                Q 401.1404296875 232.012109375 371.1 248.5
                L 371 248.55
                Q 342.676171875 265.1033203125 318.1 301.65
                L 318.1 301.7
                Q 302.6595703125 325.4048828125 296.65 354.9 293.42578125 370.997265625 292.95 388.8 293.4259765625 406.6173828125 296.65 422.7 302.6666015625 452.2056640625 318.1 475.85
                L 318.1 475.9
                Q 342.676171875 512.4966796875 371 529
                L 371.1 529.05
                Q 401.1404296875 545.587890625 429.55 550.5
                L 429.45 550.5
                Q 442.442578125 552.6341796875 451.1 552.75
                L 809.95 552.75
                Q 818.657421875 552.6341796875 831.65 550.5
                L 831.55 550.5
                Q 859.959375 545.587890625 890 529.05
                L 890.05 529
                Q 918.423828125 512.4966796875 942.95 475.9
                L 943 475.85
                Q 958.4333984375 452.2056640625 964.4 422.7 967.673828125 406.6173828125 968.1 388.8 967.674609375 371.0111328125 964.4 354.95 958.446875 325.4150390625 943 301.7
                L 942.95 301.65
                Q 918.423828125 265.1033203125 890.05 248.55
                L 890 248.5
                Q 859.959375 232.012109375 831.55 227.05
                M 811.2 280.45
                Q 811.7392578125 280.49453125 812.25 280.5 812.49140625 280.55625 812.7 280.55 813.9146484375 280.7162109375 815.1 280.85 817.8533203125 281.2271484375 820.65 281.6 820.9119140625 281.6396484375 821.15 281.65 823.6244140625 282.0486328125 826.25 282.6 826.34921875 282.65234375 826.45 282.65 839.544921875 285.702734375 851.65 291.35
                L 851.2 291.15
                Q 857.143359375 293.9744140625 863.1 297.2
                L 863.1 297.2 863.2 297.3 863.85 297.7
                Q 870.3560546875 301.8267578125 875.9 307.1
                L 875.8 307.05
                Q 880.50390625 311.5333984375 884.65 316.5
                L 884.6 316.4
                Q 887.235546875 319.5720703125 889.7 322.8
                L 889.45 322.4
                Q 892.20546875 326.04453125 894.85 329.75 896.0875 331.4236328125 897.3 333.15 899.5078125 336.641015625 901.3 340.3
                L 901.55 340.85
                Q 903.8513671875 345.46328125 905.6 350.3
                L 905.75 350.65
                Q 907.663671875 355.8025390625 909 361.1
                L 909.1 361.5
                Q 910.492578125 366.68984375 911.25 372.1 911.2875 372.2125 911.3 372.3 912.209375 378.8595703125 912.55 385.6 912.8591796875 390.9142578125 912.35 396.2
                L 912.35 396.3
                Q 911.8412109375 402.308203125 910.65 408.1
                L 910.6 408.45
                Q 909.7748046875 412.75625 908.7 417
                L 908.8 416.65
                Q 907.9 420.2732421875 906.75 423.8 906.724609375 423.8748046875 906.7 423.95 905.5607421875 427.3724609375 904.2 430.7 902.9421875 433.6890625 901.5 436.6 901.3994140625 436.8248046875 901.3 437 899.81015625 439.964453125 898.15 442.85 898.1248046875 442.9375 898.05 443
                L 898 443.05
                Q 897.4775390625 443.990625 896.85 444.85 894.3994140625 448.55390625 891.8 452.15 889.5158203125 455.2404296875 887.1 458.2
                L 887.45 457.8
                Q 885.04453125 460.73203125 882.5 463.55
                L 882.7 463.35
                Q 880.35546875 465.98046875 877.85 468.5
                L 878.15 468.2
                Q 875.997265625 470.3599609375 873.75 472.4 871.9544921875 474.0306640625 870.05 475.5
                L 869.5 475.9
                Q 867.8013671875 477.2892578125 865.95 478.5
                L 865.8 478.6
                Q 863.8283203125 479.9712890625 861.8 481.15
                L 862.15 480.95
                Q 857.672265625 483.58828125 853.05 485.6 846.619140625 488.37265625 840.1 490.9
                L 839.8 491
                Q 833.77734375 493.436328125 827.4 494.85 823.7955078125 495.605859375 820.4 496.15 817.212890625 496.6154296875 814.05 496.95 813.6556640625 497.0080078125 812.95 497.05 812.0146484375 497.1876953125 811.05 497.25 810.5267578125 497.25 810 497.25
                L 452.25 497.25
                Q 450.825 497.1982421875 449.4 497.15 449.06484375 497.1462890625 448.7 497.15 448.4296875 497.1158203125 448.1 497.05 446.5701171875 496.9029296875 445 496.75 442.492578125 496.4107421875 439.95 496.05 437.2462890625 495.6326171875 434.4 495
                L 434.9 495.1
                Q 421.762890625 492.1013671875 409.6 486.4
                L 409.55 486.35
                Q 404.2498046875 483.89765625 399.1 481.15 392.9455078125 477.558203125 387.65 472.75 382.9853515625 468.537109375 378.7 463.7
                L 378.85 463.85
                Q 376.490234375 461.17890625 374.25 458.35
                L 373.85 457.9
                Q 371.34140625 454.7708984375 368.9 451.5
                L 368.6 451.1
                Q 367.709375 449.9515625 366.85 448.75
                L 366.45 448.15
                Q 365.621484375 447.0029296875 364.85 445.85 363.026171875 443.0408203125 361.3 439.9
                L 361.3 439.95
                Q 358.8455078125 435.3814453125 356.9 430.6
                L 356.75 430.35
                Q 354.80078125 425.61015625 353.35 420.7 353.287109375 420.5126953125 353.2 420.3 351.6830078125 414.7634765625 350.65 409.1
                L 350.65 409.15
                Q 349.4849609375 402.6244140625 348.85 396
                L 348.85 395.9
                Q 348.3615234375 390.9134765625 348.65 385.9
                L 348.65 385.85
                Q 349.028125 379.501171875 350 373.3
                L 350.05 373
                Q 350.7498046875 368.70625 351.65 364.4
                L 351.65 364.5
                Q 352.4208984375 360.8890625 353.45 357.35
                L 353.45 357.3
                Q 354.4357421875 353.905859375 355.65 350.55
                L 355.75 350.3
                Q 356.9396484375 347.10390625 358.35 344
                L 358.35 343.95
                Q 359.8248046875 340.7767578125 361.5 337.65 363.128125 334.675 364.95 331.8
                L 365.45 331
                Q 365.7677734375 330.527734375 366.1 330.05
                L 366.45 329.6
                Q 368.822265625 326.2984375 371.35 323.05
                L 371.7 322.55
                Q 373.8884765625 319.7412109375 376.15 317 378.348828125 314.4728515625 380.65 312.05
                L 381.25 311.45
                Q 383.165234375 309.387890625 385.2 307.45
                L 385.45 307.2
                Q 387.30390625 305.4306640625 389.3 303.75
                L 389.8 303.35
                Q 391.6978515625 301.765625 393.7 300.2 396.092578125 298.522265625 398.55 296.85 398.660546875 296.7974609375 398.75 296.7 401.2599609375 295.4359375 403.75 294.15 403.87578125 294.1013671875 403.95 294.05 406.3728515625 292.898828125 408.8 291.8
                L 409 291.7
                Q 414.49921875 289.376171875 420.05 287.3
                L 420.15 287.3
                Q 425.5060546875 285.3125 430.95 283.7 435.44296875 282.530078125 439.55 281.65 441.863671875 281.30234375 444.1 281.05 444.7419921875 280.998828125 445.7 280.9 448.9689453125 280.4830078125 452.25 280.35
                L 808.75 280.35
                Q 809.9861328125 280.401953125 811.2 280.45 Z"/>
                </g>


                <OuterPath ref={outerPathRef}/>
                <MiddlePath ref={middlePathRef}/>
                <InnerPath ref={innerPathRef}/>
            
                </defs>

                <g transform="matrix( 1.437255859375, 0, 0, 1.437255859375, -266.15,-198.8) ">
                <use xlinkHref="#Layer3_0_FILL"/>
                </g>

                <g transform="matrix( 1, 0, 0, 1, 0,0) ">
                <use xlinkHref="#Layer2_0_1_STROKES"/>
                </g>

                <g transform="matrix( 1, 0, 0, 1, 0,0) ">
                <use xlinkHref="#Layer1_0_1_STROKES"/>
                </g>

                <g transform="matrix( 1, 0, 0, 1, 0,0) ">
                <use xlinkHref="#Layer0_0_1_STROKES"/>
                </g>
                </svg>
                </div>
            </>
        )
}

function OuterPath(props) {
    return (
        <path ref={props.ref} id="Layer2_0_1_STROKES" stroke="#000000" stroke-width="0" stroke-linejoin="round" stroke-linecap="round" fill="none" d="
        M 381.7 84.5
        Q 366.75 84.55 344.45 88.3 343.75 88.35 343.15 88.5 296.75 96.55 247.9 123.5 246.95 124 246.1 124.6 198.65 151.8 157.85 212.6 157.7 212.9 157.55 213.1 131.15 253.2 121.05 303.45 115.65 329.75 114.95 359 114.95 360 114.95 361 115.65 390.2 121.05 416.65 131.15 466.7 157.45 506.95 157.9 507.6 158.4 508.35 199.3 568.9 246.85 596.05 247.4 596.35 247.9 596.65 296.8 623.55 343.15 631.65 343.9 631.7 344.6 631.85 366.8 635.45 381.7 635.55
        L 898.4 635.55
        Q 913.1 635.45 935.4 631.85 936.05 631.7 936.75 631.65 982.6 623.6 1030.95 597.2
        L 1032.05 596.65
        Q 1032.6 596.3 1033.1 596 1080.9 568.7 1122.15 507.55 1122.8 506.55 1123.45 505.45 1148.95 465.8 1158.95 416.7
        L 1159.05 416.5
        Q 1164.25 390.2 1165.05 361.15 1165.05 360 1165.05 358.95 1164.25 329.8 1159.05 303.6
        L 1158.95 303.45
        Q 1148.9 254.1 1123.3 214.5 1122.75 213.55 1122.15 212.6 1080.9 151.25 1033.1 124.1 1032.05 123.45 1030.95 122.95 982.6 96.4 936.85 88.5 936.2 88.35 935.55 88.3 913.2 84.55 898.4 84.5
        L 381.7 84.5 Z"/>
    )
}

function MiddlePath(props) {
    return (
        <>
<path ref={props.ref} id="Layer1_0_1_STROKES" stroke="#000000" stroke-width="0" stroke-linejoin="round" stroke-linecap="round" fill="none" d="
                M 267.05 158.45
                Q 310.25 134.65 351.05 127.6
                L 350.95 127.6
                Q 369.6 124.5 382.1 124.35
                L 897.9 124.35
                Q 910.3 124.5 929 127.6
                L 928.85 127.6
                Q 969.65 134.65 1012.85 158.45
                L 1013 158.5
                Q 1053.7 182.2 1089.05 234.8
                L 1089.05 234.9
                Q 1111.25 268.9 1119.85 311.35 1124.45 334.4 1125.2 360 1124.45 385.6 1119.85 408.75 1111.25 451.15 1089.05 485.2
                L 1089.05 485.25
                Q 1053.7 537.8 1013 561.6
                L 1012.85 561.65
                Q 969.65 585.35 928.85 592.5
                L 929 592.5
                Q 910.3 595.5 897.9 595.65
                L 382.1 595.65
                Q 369.6 595.5 350.95 592.5
                L 351.05 592.5
                Q 310.25 585.35 267.05 561.65
                L 267 561.6
                Q 226.25 537.8 190.95 485.25
                L 190.9 485.2
                Q 168.7 451.15 160.15 408.75 155.45 385.6 154.8 360 155.45 334.4 160.15 311.35 168.7 268.9 190.9 234.9
                L 190.95 234.8
                Q 226.25 182.2 267 158.5
                L 267.05 158.45 Z">
                    </path>
    </>
            )
}

function InnerPath(props) {
    return (
                <path ref={props.ref} id="Layer0_0_1_STROKES" stroke="#000000" stroke-width="0" stroke-linejoin="round" stroke-linecap="round" fill="none" d="
                M 357.9 166.9
                Q 358.5 166.75 359.2 166.7 373.05 164.45 382.6 164.25
                L 897.45 164.25
                Q 906.85 164.45 920.8 166.7 921.4 166.75 922.1 166.9 956.45 173 992.95 193 1025.95 212.85 1055.05 255.75 1055.35 256.15 1055.7 256.75 1073.65 284.5 1080.75 319.2
                L 1080.75 319.35
                Q 1084.6 338.65 1085.3 360 1084.6 381.4 1080.75 400.8 1080.75 400.9 1080.75 400.95 1073.65 435.6 1055.6 463.4 1055.35 463.75 1055.1 464.2 1026.2 506.75 993.45 526.8 956.65 546.9 922 553.15 921.45 553.25 920.95 553.4 906.95 555.55 897.45 555.75
                L 382.6 555.75
                Q 373.05 555.55 359.05 553.4 358.5 553.25 357.95 553.15 323.85 547.05 287.75 527.5 287.4 527.3 287.1 527.15 253.5 506.9 224.1 463.05 206.2 435.3 199.25 400.9
                L 199.25 400.8
                Q 195.35 381.4 194.75 360 195.35 338.6 199.25 319.25 206.2 284.7 224.1 257.05 253.5 213.2 287.05 193 287.25 192.85 287.4 192.8 323.6 173 357.9 166.9 Z"/>
    )
}
